import SavedSearches from './SavedSearches.container';

export default SavedSearches;
